module.exports = __webpack_public_path__ + "img/logo.4997c797.png";